//ANCHOR PAGEVIEW (INIT GA4)
window.GTM_PUSH({ event: 'page_viewed' }).then(() => {
  //ANCHOR VIEW_ITEM
  if (THEME_INFO.pageType == 'product') {
    GtmDataExtractor.sendViewEvent('gtm-view-item', {
      event: 'view_item',
      method: 'load',
    })
    const sendSelectedVariantEvent = (event) => {
      if (event.gtmSelectedVariantHandled) return
      const variant = event.detail && event.detail.variant
      if (!variant || !variant.variantId) return

      event.gtmSelectedVariantHandled = true
      window.eventFetch(window.THEME_INFO.productId, variant.variantId, {
        event: 'selected_variant',
        method: 'selected',
      })
    }

    document.addEventListener('onSelectVariant', sendSelectedVariantEvent)

    setTimeout(() => {
      const el = document.getElementById('relatedColorSizes')
      if (el) {
        el.addEventListener('onSelectVariant', sendSelectedVariantEvent)
      }
    }, 2000)
  }
  //ANCHOR VIEW_Item_list
  if (THEME_INFO.pageType == 'collection') {
    GtmDataExtractor.sendViewEvent('gtm-collections', {
      event: 'view_item_list',
      method: 'load',
    })
    document.addEventListener('collection:reloaded', function () {
      GtmDataExtractor.sendViewEvent('gtm-collections', {
        event: 'view_item_list',
        method: 'refresh',
      })
    })
  }
  //ANCHOR CART_EVENTs
  document.addEventListener('cart:updated', function (evt) {
    let cart = evt.detail.cart
    let method = THEME_INFO.pageType == 'cart' ? 'cart_page' : 'sidebar'
    let event =
      cart.items_removed.length > 0 ? 'remove_from_cart' : 'add_to_cart'
    let productCart =
      cart.items_removed.length > 0
        ? cart.items_removed[0]
        : cart.items_added[0]
    window.eventFetch(productCart.product_id, productCart.variant_id, {
      event: event,
      method: method,
    })
  })
  document.addEventListener('ajaxProduct:added', function (evt) {
    let productCart = evt.detail.product
    window.eventFetch(productCart.product_id, productCart.variant_id, {
      event: 'add_to_cart',
      method: evt.detail && evt.detail.quickBuy ? 'quick-buy' : 'pdp',
    })
  })
  document.addEventListener('quickview:open', function (evt) {
    const productId = evt.detail && evt.detail.productId
    const modal = productId
      ? document.getElementById('QuickShopModal-' + productId)
      : null
    const title = modal
      ? modal.querySelector('[data-product-title]') ||
        modal.querySelector('.product-single__title')
      : null

    window.GTM_PUSH({
      event: 'quick_buy_open',
      method: 'quick-buy',
      product_title: title ? title.textContent.trim() : '',
    })
  })
  if (THEME_INFO.pageType == 'search') {
    GtmDataExtractor.sendViewEvent('grid--uniform', {
      event: 'search',
      method: 'load',
    })
  }
})
